import { render, staticRenderFns } from "./OperaChangeShopRecordWindow.vue?vue&type=template&id=6dd6b8dd&scoped=true&"
import script from "./OperaChangeShopRecordWindow.vue?vue&type=script&lang=js&"
export * from "./OperaChangeShopRecordWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaChangeShopRecordWindow.vue?vue&type=style&index=0&id=6dd6b8dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd6b8dd",
  null
  
)

export default component.exports